import { Grid } from '@mui/material'
import { FC } from 'react'
import { MenuItemCard } from 'components/ordering/MenuItemCard'
import { MenuItem } from 'models'
import { calculateUnavailableMessageInMenu } from 'services'

interface MenuItemsGridProps {
  items: MenuItem[]
  onItemClick?: (item: MenuItem) => void
  unavailableMessage?: string
  calculateUnavailableMessageWhenSearching?: (item: MenuItem) => any
}

export const MenuItemsGrid: FC<MenuItemsGridProps> = ({
  items,
  onItemClick,
  unavailableMessage,
  calculateUnavailableMessageWhenSearching,
}) => {
  return (
    <Grid container spacing={2.5} rowSpacing={1.5}>
      {items?.map((item) => {
        const itemUnavailableMessage = calculateUnavailableMessageInMenu(
          item,
          unavailableMessage,
          calculateUnavailableMessageWhenSearching,
        )

        return (
          <Grid key={item.id} item lg={4} md={6} sm={12} xs={12}>
            <MenuItemCard
              item={item}
              onClick={onItemClick ? () => onItemClick(item) : undefined}
              unavailableMessage={itemUnavailableMessage}
              viewType="grid"
            />
          </Grid>
        )
      })}
    </Grid>
  )
}
